// landing-pages/src/App.tsx
import React from "react";
import "./App.css";
import DhyanaEndlessScroll from "./components/DhyanaEndlessScroll";
import DebugPage from "./components/DebugPage";

export default function App() {
  // Gate debug page: only show in development or with debug token
  const isDevelopment = process.env.NODE_ENV === 'development';
  const urlParams = new URLSearchParams(window.location.search);
  const debugToken = urlParams.get('debug');
  const validDebugToken = debugToken === 'dhyana2024' || isDevelopment;
  
  const isDebugMode = (window.location.pathname === '/debug' || 
                      window.location.search.includes('debug=')) && 
                      validDebugToken;
  
  if (isDebugMode) {
    return <DebugPage />;
  }
  
  return <DhyanaEndlessScroll />;
}
